import { type ContractorInputType, ContractorOrigin } from 'config'
import type { InputType } from 'config/input.type.constants'
import { isVisibleFieldVisibleProps } from 'utils/loan'

const inputsToFieldValues = (inputs: Record<string, InputType>) =>
  Object.fromEntries(Object.keys(inputs).map((key) => [key, inputs[key].value]))

export const getContractorFieldValues = (
  generalInputs: Record<string, InputType>,
  capabilityInputs: Record<string, InputType> = {},
) => ({
  [ContractorOrigin.GeneralInformation]: inputsToFieldValues(generalInputs),
  [ContractorOrigin.CapabilityStatement]: inputsToFieldValues(capabilityInputs),
})

export const isContractorInputVisible = (
  input: InputType,
  contractorFieldValues: ReturnType<typeof getContractorFieldValues>,
) => {
  const { visible, visibleLogic, visibleAccountTypes, visibleLoanTypes } = input as ContractorInputType
  if (visible === false) return false

  return isVisibleFieldVisibleProps({ visibleLogic, visibleAccountTypes, visibleLoanTypes }, undefined, {
    additionalFieldValues: contractorFieldValues,
  })
}

export const getVisibleContractorInputs = (
  inputs: Record<string, InputType>,
  contractorFieldValues: ReturnType<typeof getContractorFieldValues>,
) =>
  Object.fromEntries(
    Object.keys(inputs)
      .filter((key) => isContractorInputVisible(inputs[key], contractorFieldValues))
      .map((key) => [key, inputs[key]]),
  )
